// extracted by mini-css-extract-plugin
export default {"branchTableWrapper":"HistoryCheckBranch_branchTableWrapper__+Pg6b"};